import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgOrientationBoth = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.35 7.95007C13.35 7.45302 13.7529 7.05007 14.25 7.05007L21 7.05007C22.4034 7.05007 23.85 8.01757 23.85 9.55722L23.85 17.5929C23.85 19.1326 22.4034 20.1001 21 20.1001L14.34 20.1001C13.8429 20.1001 13.44 19.6971 13.44 19.2001C13.44 18.703 13.8429 18.3001 14.34 18.3001L21 18.3001C21.7506 18.3001 22.05 17.8285 22.05 17.5929L22.05 9.55722C22.05 9.32166 21.7506 8.85007 21 8.85007L14.25 8.85007C13.7529 8.85007 13.35 8.44713 13.35 7.95007Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25896 3.4602C2.1183 3.64467 2.00699 3.93643 2.00699 4.29358L2.00699 19.7064C2.00699 20.0636 2.1183 20.3553 2.25896 20.5398C2.39889 20.7233 2.53299 20.7661 2.61748 20.7661H9.96247C10.047 20.7661 10.1811 20.7233 10.321 20.5398C10.4617 20.3553 10.573 20.0636 10.573 19.7064L10.573 4.29358C10.573 3.93643 10.4617 3.64467 10.321 3.4602C10.1811 3.27668 10.047 3.23394 9.96247 3.23394L2.61748 3.23394C2.53299 3.23394 2.39889 3.27668 2.25896 3.4602ZM0.289978 4.29358C0.289978 2.97501 1.13693 1.5 2.61748 1.5L9.96247 1.5C11.443 1.5 12.29 2.97501 12.29 4.29358L12.29 19.7064C12.29 21.025 11.443 22.5 9.96247 22.5H2.61748C1.13693 22.5 0.289978 21.025 0.289978 19.7064L0.289978 4.29358Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgOrientationBoth)
const IconSvgOrientationBoth = createIcon(ForwardRef, 'SvgOrientationBoth')
export default IconSvgOrientationBoth
